import React, { Component } from 'react';
import { convertToMoney } from '../utils/formats';

var config = process.env;

class ProductBranchSettingsComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            branches: [],
            rows: {},
            savingBranchId: null,
        };
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        this.setState({ loading: true });

        fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}branch/product/${this.props.code}`, {
            method: 'GET',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            }
        })
        .then(results => results.json())
        .then((data) => {
            if (data.error > 0) {
                alert(data.message);
                return;
            }

            const branches = data.data || [];
            const rows = {};
            branches.forEach((branch) => {
                rows[branch.id] = {
                    stock: branch.stock ?? 0,
                    minStock: branch.minStock ?? 0,
                    suggestionStock: branch.suggestionStock ?? 0,
                    price: branch.price ?? '',
                    isVisible: branch.isVisible == null ? true : !!branch.isVisible,
                    externalItemsText: Array.isArray(branch.externalItems) ? branch.externalItems.join(', ') : '',
                };
            });

            this.setState({
                loading: false,
                branches,
                rows,
            });
        })
        .catch(() => {
            this.setState({ loading: false });
        });
    }

    handleChange = (branchId, field, value) => {
        this.setState((prevState) => ({
            rows: {
                ...prevState.rows,
                [branchId]: {
                    ...prevState.rows[branchId],
                    [field]: value,
                },
            },
        }));
    }

    saveBranch = (branchId) => {
        const row = this.state.rows[branchId];
        const externalItems = String(row.externalItemsText || '')
            .split(',')
            .map((item) => item.trim())
            .filter(Boolean);

        this.setState({ savingBranchId: branchId });
        fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}branch/${branchId}/product/${this.props.code}`, {
            method: 'PATCH',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                stock: Number(row.stock || 0),
                minStock: Number(row.minStock || 0),
                suggestionStock: Number(row.suggestionStock || 0),
                price: row.price === '' ? null : Number(row.price),
                isVisible: !!row.isVisible,
                externalItems,
            }),
        })
        .then(results => results.json())
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                return;
            }

            // Aviso más temprano posible: la publicación que se acaba de vincular ofrece
            // envío gratis SIN que ML lo obligue, o sea que el flete lo paga Enigma entero.
            // Es advertencia y no bloqueo (puede ser deliberado), pero se muestra fuerte
            // porque en productos baratos la venta termina en pérdida.
            const aviso = (data.data && data.data.avisoEnvioGratis) || [];
            if (aviso.length > 0) {
                const detalle = aviso.map((r) => `• ${r.externalItemId} (${convertToMoney(r.price)})`).join('\n');
                alert(
                    '⚠️ Guardado, pero atención:\n\n' +
                    `${aviso.length} publicación(es) vinculada(s) ofrecen ENVÍO GRATIS y MercadoLibre no lo obliga.\n` +
                    'En esos casos ML no compensa nada: el flete lo pagamos nosotros enteros.\n\n' +
                    detalle +
                    '\n\nSi no es intencional, entrá a la publicación en ML y desactivá el envío gratis.'
                );
            }

            this.loadData();
        })
        .catch(() => {
            // Sin esto, un error de red dejaba una unhandled rejection y el botón volvía a
            // "Guardar" sin ningún feedback: parecía guardado y no lo estaba.
            alert('No se pudo guardar. Revisá la conexión y reintentá.');
        })
        .finally(() => {
            this.setState({ savingBranchId: null });
        });
    }

    renderRows = () => {
        if (this.state.loading) {
            return (
                <tr>
                    <td colSpan="8" className="text-center">Cargando sucursales...</td>
                </tr>
            );
        }

        return this.state.branches.map((branch) => {
            const row = this.state.rows[branch.id] || {
                stock: 0,
                minStock: 0,
                suggestionStock: 0,
                price: '',
                isVisible: true,
                externalItemsText: '',
            };

            return (
                <tr key={branch.id}>
                    <td>{branch.name}</td>
                    <td>
                        <input
                            type="number"
                            min="0"
                            className="form-control"
                            value={row.stock}
                            onChange={(event) => this.handleChange(branch.id, 'stock', event.target.value)}
                        />
                    </td>
                    <td>
                        <input
                            type="number"
                            min="0"
                            className="form-control"
                            value={row.minStock}
                            onChange={(event) => this.handleChange(branch.id, 'minStock', event.target.value)}
                        />
                    </td>
                    <td>
                        <input
                            type="number"
                            min="0"
                            className="form-control"
                            value={row.suggestionStock}
                            onChange={(event) => this.handleChange(branch.id, 'suggestionStock', event.target.value)}
                        />
                    </td>
                    <td>
                        <input
                            type="number"
                            min="0"
                            className="form-control"
                            placeholder="Base"
                            value={row.price}
                            onChange={(event) => this.handleChange(branch.id, 'price', event.target.value)}
                        />
                    </td>
                    <td>
                        <textarea
                            rows="2"
                            className="form-control"
                            placeholder="MLU123, MLU456"
                            value={row.externalItemsText}
                            onChange={(event) => this.handleChange(branch.id, 'externalItemsText', event.target.value)}
                        />
                    </td>
                    <td className="text-center">
                        <input
                            type="checkbox"
                            checked={!!row.isVisible}
                            onChange={(event) => this.handleChange(branch.id, 'isVisible', event.target.checked)}
                        />
                    </td>
                    <td className="text-right">
                        <button
                            type="button"
                            className="btn btn-sm btn-outline-primary"
                            onClick={() => this.saveBranch(branch.id)}
                            disabled={this.state.savingBranchId === branch.id}
                        >
                            {this.state.savingBranchId === branch.id ? 'Guardando...' : 'Guardar'}
                        </button>
                    </td>
                </tr>
            );
        });
    }

    render() {
        return (
            <div className="card card-small mb-4">
                <div className="card-header border-bottom">
                    <h6 className="m-0">Configuración por sucursal</h6>
                </div>
                <div className="card-body">
                    <p className="text-muted">
                        Ajustá stock, mínimos, sugeridos, precio específico, visibilidad y publicaciones de MercadoLibre por sucursal.
                    </p>
                    <div className="table-responsive">
                        <table className="table mb-0">
                            <thead>
                                <tr>
                                    <th>Sucursal</th>
                                    <th>Stock</th>
                                    <th>Mínimo</th>
                                    <th>Sugerido</th>
                                    <th>Precio</th>
                                    <th>Publicaciones ML</th>
                                    <th>Visible</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.renderRows()}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

export default ProductBranchSettingsComponent;
